import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="lg:w-1/2 relative overflow-hidden flex items-center justify-center py-16 lg:py-0">
        <img
          src="https://readdy.ai/api/search-image?query=Close%20up%20shot%20of%20hands%20wrapped%20around%20a%20warm%20ceramic%20mug%2C%20soft%20morning%20sunlight%20streaming%20through%20a%20window%2C%20throw%20blanket%20and%20cushions%20slightly%20visible%20in%20background%2C%20peaceful%20hopeful%20atmosphere%2C%20steam%20rising%20gently%20from%20the%20mug%2C%20cream%20beige%20and%20soft%20sage%20tones%2C%20feeling%20of%20calm%20readiness%20and%20quiet%20confidence%2C%20lifestyle%20photography%2C%20hygge%20inspired%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20no%20faces%20visible%2C%20warm%20and%20inviting&width=900&height=700&seq=cta-warm-v4&orientation=portrait"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-accent-500/15 to-transparent" />
        <div className="relative z-10 p-10 md:p-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm text-xs uppercase tracking-wider text-foreground-800 font-semibold">
            Your next chapter
          </span>
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-background-50 leading-none mt-6 drop-shadow-sm">
            Free intake.
            <br />
            Paperwork handled.
            <br />
            You walk.
          </h2>
          <p className="mt-5 text-background-50/90 text-[15px] max-w-[320px] leading-relaxed">
            Insurance pulled. Financing arranged. Care team connected. All the
            admin that normally slows you down — handled. For free.
          </p>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex items-center justify-center py-16 lg:py-0 px-6 md:px-10">
        <div className="max-w-[460px] text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-accent-50 mx-auto mb-6">
            <i className="ri-checkbox-circle-line text-accent-600 text-2xl"></i>
          </div>
          <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
            Whether you need a
            <br />
            prosthetist or already
            <br />
            have one — start here.
          </h3>
          <p className="mt-5 text-[15px] md:text-base text-foreground-500 leading-relaxed">
            Your free intake takes about 5 minutes. From there, our system
            handles the rest — medical language, insurance, financing, care team
            coordination. We'll find you a great prosthetist or connect with the
            one you already love. Either way, walking comfortably is closer than
            you think.
          </p>
          <Link
            to="/intake"
            className="inline-flex items-center gap-2 mt-8 bg-primary-500 text-background-50 px-9 py-4 rounded-full text-[15px] font-semibold hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Start your journey now
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
          <p className="mt-4 text-xs text-foreground-400">
            Free for amputees. Takes about 5 minutes. No obligation.
          </p>
        </div>
      </div>
    </section>
  );
}
